import {RootStore} from '../stores/RootStore';
import {PanoramaTransactions} from '../../../constants/app';
import {makeAutoObservable, observable} from 'mobx';
import {mapUserInputSelectionMapToChoices} from '../mappers/mapUserInputSelectionMapToChoices';
import {handleQuantityChange} from './handlers/handleQuantityChange';
import {SPECS} from '../../../specs';

export type OverrideCallback = (resume: (a: unknown) => void, cancel: (a: unknown) => void) => void;
export type OnChoiceSelectedCallbackType = (choices: ReturnType<typeof mapUserInputSelectionMapToChoices>) => void;
export type OnQuantityChangedCallbackType = (value: number) => void;
export const ProductCollectionNameV3 = 'StoreCatalog/Products';
export const ProductCollectionNameV1 = 'Stores/Products';

export class RootWidgetApiService {
  public onAddToCartInterruption: any = null;
  public onBuyNowInterruption: any = null;
  public labelOverrides = {
    cta: {
      addToCart: null as null | string,
      buyNow: null as null | string,
    },
  };

  public onChoiceSelectedCallback: OnChoiceSelectedCallbackType | null = null;
  public onQuantityChangedCallback: OnQuantityChangedCallbackType | null = null;

  constructor(private readonly rootStore: RootStore) {
    makeAutoObservable(this, {
      labelOverrides: observable.deep,
    });
  }

  public getProductWixCode() {
    const shouldUseStoresCatalogV3PPOB = this.rootStore.controllerParams.flowAPI.experiments.enabled(
      SPECS.UseStoresCatalogV3PPOB,
    );
    const collectionName = shouldUseStoresCatalogV3PPOB ? ProductCollectionNameV3 : ProductCollectionNameV1;
    return this.rootStore.reportPanoramaTransaction(PanoramaTransactions.WixCodeGetProduct, () =>
      // @ts-expect-error 'data' is coming in runtime
      this.rootStore.wixCodeApi.data.get(collectionName, this.rootStore.$state.product.id),
    );
  }

  public getCustomText() {
    return this.rootStore.reportPanoramaTransaction(PanoramaTransactions.WixCodeGetCustomTextFieldValues, () =>
      this.rootStore.$state.userInput.text.map((text) => (text ? text : '')),
    );
  }

  public addToCartOverride(callback: OverrideCallback) {
    this.onAddToCartInterruption = () =>
      new Promise((resolve, reject) => {
        callback(resolve, () => reject('cancel'));
      });
  }

  public onBuyNowOverride(callback: OverrideCallback) {
    this.onBuyNowInterruption = () =>
      new Promise((resolve, reject) => {
        callback(resolve, () => reject('cancel'));
      });
  }

  public setAddToCartLabel(value: string) {
    this.labelOverrides.cta.addToCart = value;
  }

  public setBuyNowLabel(value: string) {
    this.labelOverrides.cta.buyNow = value;
  }

  public onChoiceSelected(callback: OnChoiceSelectedCallbackType) {
    this.onChoiceSelectedCallback = callback;
  }

  public getSelectedVariantId(): string | undefined {
    return this.rootStore.$state?.selectedVariant?.id;
  }

  public getSelectedChoices(): ReturnType<typeof mapUserInputSelectionMapToChoices> {
    return mapUserInputSelectionMapToChoices(this.rootStore);
  }
  public getQuantity() {
    return this.rootStore.$state.quantityInput;
  }

  public setQuantity(value: number) {
    handleQuantityChange(this.rootStore)({data: value});
  }

  public onQuantityChanged(callback: OnQuantityChangedCallbackType) {
    this.onQuantityChangedCallback = callback;
  }
}
